import { render } from "./ArgonTextarea.vue?vue&type=template&id=5a21f3f2"
import script from "./ArgonTextarea.vue?vue&type=script&lang=js"
export * from "./ArgonTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/Laravel/mistock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__